var _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9627 8.8525V10.2865L14.2166 10.0371L15.0416 9.16424L15.6762 8.66546L16.8185 8.29138L17.8974 8.04199H20.0551L21.1975 8.29138L22.2129 8.66546L22.8475 9.16424L23.736 10.0371L24.3071 10.8476L24.7514 11.9075L25.0052 12.9051L25.1321 13.7779L25.1956 14.5261L25.2591 15.4613V24.4393L25.0687 24.6886L24.9418 24.8133L24.6879 25.0004H20.309L20.0551 24.8133L19.9282 24.6886L19.8013 24.4393V15.4613L19.6109 14.5261L19.2936 13.7779L18.9763 13.3415L18.4686 12.9051L18.0243 12.6557L17.6435 12.531H16.5012L15.9935 12.6557L15.4858 12.9051L14.9781 13.3415L14.5973 13.7779L14.2166 14.5261L13.9627 15.4613V24.4393L13.8178 24.6886L13.6454 24.8133L13.3915 25.0004H9.13954L8.88569 24.8133L8.75876 24.6886L8.63184 24.4393V8.8525L8.75876 8.54077L8.88569 8.41607L9.26646 8.29138H13.3281L13.5819 8.41607L13.7723 8.54077L13.9627 8.8525Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15607 24.2528V8.91546L6.02914 8.66607L5.83875 8.47903L5.52144 8.29199H1.45982L1.14251 8.47903L0.952121 8.66607L0.825195 8.91546V24.2528L0.888658 24.5646L1.07905 24.7516L1.39636 24.9386H5.5849L5.90222 24.7516L6.0926 24.5646L6.15607 24.2528Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.49045,
    cy: 3.42908,
    rx: 3.49045,
    ry: 3.42908,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.c50b6e50a146722957e784db84fe10e2.svg";
export { ForwardRef as ReactComponent };